/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

import moment from 'moment'
Vue.prototype.moment = moment

window.select2 = require('select2');
window.numeral = require('numeral');

require('sweetalert');
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';


import vue2Dropzone from 'vue2-dropzone'
Vue.component('vue-dropzone', vue2Dropzone);

Vue.use(VueSweetalert2);

import vueNumeralFilterInstaller from 'vue-numeral-filter';
Vue.use(vueNumeralFilterInstaller);

Vue.filter('result', function (value) {
    if (value < 0.1) {
        return numeral(value).format('0.0e+0');
    } else {
        return parseFloat(value).toFixed(1);
    }
})

Vue.filter('percentage', function (value) {
    if (value < 0.1) {
        return '< 0.1%';
    } else {
        return parseFloat(value).toFixed(1) +'%';
    }
})

Vue.directive('tooltip', function(el, binding){
    $(el).tooltip({
             title: binding.value,
             placement: binding.arg,
             trigger: 'hover'
         })
})

import ECharts from 'vue-echarts'
import {
  use,
  registerMap,
} from "echarts/core"

// import ECharts modules manually to reduce bundle size
import {
  CanvasRenderer
} from 'echarts/renderers'
import {
  MapChart,
  PieChart,
  BarChart,
} from 'echarts/charts'
import {
  GridComponent,
  VisualMapComponent,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
} from 'echarts/components'

use([
  MapChart,
  PieChart,
  BarChart,
  CanvasRenderer,
  GridComponent,
  VisualMapComponent,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
])

import worldMap from "./world.json";
registerMap("world", worldMap);

Vue.component('v-chart', ECharts)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

require('./components/bootstrap');

const eventHub = new Vue() // Single event hub

Vue.mixin({
  data: function () {
      return {
          eventHub: eventHub
      }
  }, methods: {
    openModal(selector) {
        var $element = $(selector);
        $element.modal();
        setTimeout(function() {
          if ($element.find('input').length > 0) {
              $element.find('input').first().focus();
          }
        }, 500);
    },
  }
});

function updateFunction (el, binding) {
  // get options from binding value.
  // v-select="THIS-IS-THE-BINDING-VALUE"
  let options = binding.value || {};

  $('.modal-body select').css('width', '100%');

  // set up select2
  $(el).select2(options).on("select2:select select2:unselect", (e) => {
    // v-model looks for
    //  - an event named "change"
    //  - a value with property path "$event.target.value"
    el.dispatchEvent(new Event('change', { target: e.target }));
  });

  setTimeout(() => {
    $(el).trigger('change');
  }, 50);
}

function unbindFunction(el, binding) {
    $(el).off().select2('destroy')
}
Vue.directive('select', {
  inserted: updateFunction ,
  componentUpdated: updateFunction,
  unbind: unbindFunction,
});

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
